import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, PackageSearch, FileText, FileSignature, FolderKanban, Gift, User } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import PageHero from "../../components/ui-custom/PageHero";

const tabs = [
  { label: "Overview", to: "/portal", icon: LayoutDashboard, end: true },
  { label: "My Account", to: "/portal/account", icon: User },
  { label: "POs / Orders", to: "/portal/orders", icon: PackageSearch },
  { label: "Invoices", to: "/portal/invoices", icon: FileText },
  { label: "Quotations", to: "/portal/quotations", icon: FileSignature },
  { label: "Projects", to: "/portal/projects", icon: FolderKanban },
  { label: "Rewards", to: "/portal/rewards", icon: Gift },
];

const PortalLayout = () => {
  const { user } = useAuth();

  return (
    <div>
      <PageHero
        eyebrow="Client Portal"
        title={`Welcome${user?.name ? ", " + user.name.split(" ")[0] : ""}`}
        subtitle="Track your orders, invoices, projects and partner rewards with Quality Power."
      />
      <section className="px-6 pb-28">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-wrap gap-2 mb-10 border-b border-border/10 pb-4">
            {tabs.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                end={tab.end}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium tracking-wide transition-colors border ${
                    isActive
                      ? "bg-qcyan/10 border-qcyan/50 text-qcyan"
                      : "border-border/10 text-muted-foreground hover:text-foreground hover:border-border/20"
                  }`
                }
              >
                <tab.icon size={15} />
                {tab.label}
              </NavLink>
            ))}
          </div>
          <Outlet />
        </div>
      </section>
    </div>
  );
};

export default PortalLayout;
